import { alpha, type Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const CoverageTableWCMessageDesctopStyle: StyleExtend<Theme> = {
  gap: 1.25,
  flexDirection: 'row',
  p: 2,
  background: (theme) => alpha(theme.palette.customColors.copper as string, 0.1),
  '&:first-of-type': {
    borderRadius: (theme) => theme.spacing(0.5),
  },
  '.workers-warning-icon': {
    svg: {
      width: (theme) => theme.spacing(4),
      height: (theme) => theme.spacing(4),
      path: {
        stroke: (theme) => theme.palette.customColors.copper,
      },
    },
  },
};

export const CoverageTableWCMessageMobileStyle: StyleExtend<Theme> = {
  borderBottom: (theme) => `1px solid ${theme.palette.customColors.cream} !important`,
  gap: 1.25,
  flexDirection: 'row',
  p: 2,
  background: (theme) => alpha(theme.palette.customColors.copper as string, 0.1),
  '&:first-of-type': {
    borderRadius: (theme) => theme.spacing(0.5),
  },
};

export const CoverageTableWCMessageTelLinkStyle: StyleExtend<Theme> = {
  fontWeight: (theme) => theme.typography.price.fontWeight,
  background: 'unset !important',
  padding: '0 !important',
  ml: 0.5,
  textDecoration: 'none',
  whiteSpace: 'nowrap',
};
